import { useContext } from "react";

import DeleteService from "../../images/icon_delete_service.svg";
import { formatMoney } from "../../utils/numbers";
import { CurrencyContext } from "../CurrencyContext/CurrencyContext";
import { VolanteDetailContainer } from "./VolanteDetailStyles";

function VolanteDetailCpt(props) {
  const { detail, isTotal, onRemoveClick, volante } = props;
  const {
    description,
    sellingValue,
    igv,
    sellingPrice,
    discount,
    netValue,
    category,
    amount,
  } = detail;

  const [useDollars] = useContext(CurrencyContext);
  const color = category === "additional_service" && "#88B13B";
  return (
    <VolanteDetailContainer isTotal={isTotal}>
      <div style={{ color }}>{description ? description : "Total"}</div>
      <div style={{ color }}>{formatMoney(sellingValue, useDollars)}</div>
      <div className="discount" style={{ color }}>
        {formatMoney(discount, useDollars)}
      </div>
      <div style={{ color }}>{formatMoney(netValue, useDollars)}</div>
      <div style={{ color }}>{formatMoney(igv, useDollars)}</div>
      <div className="selling-value" style={{ color }}>
        {formatMoney(sellingPrice, useDollars)}
      </div>
      <div style={{ color }}>{amount}</div>
      {category === "additional_service" && (
        <div>
          {volante.payment_status.option === "unquoted" && (
            <img
              style={{ cursor: "pointer" }}
              src={DeleteService}
              alt=""
              onClick={() => onRemoveClick(detail)}
            />
          )}
        </div>
      )}
    </VolanteDetailContainer>
  );
}

export default VolanteDetailCpt;
